(function () {
  function initHoverCardVideos() {
    document.querySelectorAll('.card-wrapper').forEach((card) => {
      const video = card.querySelector('video.secondary-media-video');
      if (!video) return;

      // Play on hover (desktop)
      card.addEventListener('mouseenter', () => {
        try {
          video.currentTime = 0;
          video.play();
        } catch (e) {}
      });

      // Pause when hover ends
      card.addEventListener('mouseleave', () => {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      });

      // Accessibility: keyboard focus
      card.addEventListener('focusin', () => {
        try { video.play(); } catch (e) {}
      });
      card.addEventListener('focusout', () => {
        try { video.pause(); } catch (e) {}
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHoverCardVideos);
  document.addEventListener('shopify:section:load', initHoverCardVideos);
})();
